export namespace AuthActions {
    export class SignOut {
        public static readonly type = "[Auth] SignOut";
    }

    export class GetCurrentAccount {
        public static readonly type = "[Auth] GetCurrentAccount";
    }
}
